export default {
  name: "ServerPaginatedTable",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    table_id: {
      type: String,
      default: "server_paginated_table",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loading_text: {
      type: String,
      default: "Loading records...",
    },
    empty_message: {
      type: String,
      default: "No matching records available",
    },
    page_number: {
      type: Number,
      default: 1,
    },
    total_pages: {
      type: Number,
      default: 1,
    },
    prev_page: {
      type: Number,
      default: null,
    },
    next_page: {
      type: Number,
      default: null,
    },
    total_count: {
      type: Number,
      default: 0,
    },
    page_size: {
      type: Number,
      default: 0,
    },
    show_pagination: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["page-change"],
  computed: {
    safe_data() {
      return Array.isArray(this.data) ? this.data : [];
    },
    column_span() {
      return this.headers.length + (this.$slots.actions ? 1 : 0);
    },
    summary_text() {
      const item_count = this.safe_data.length;
      if (!item_count) {
        return "No records available";
      }
      if (!this.page_size || !this.total_count) {
        return `Showing ${item_count} records`;
      }
      const start = ((this.page_number - 1) * this.page_size) + 1;
      const end = start + item_count - 1;
      return `Showing ${start}-${end} of ${this.total_count}`;
    },
  },
  methods: {
    change_page(page_number) {
      if (!page_number || page_number === this.page_number) {
        return;
      }
      this.$emit("page-change", page_number);
    },
  },
};
